module.exports = __webpack_public_path__ + "img/Wagon_Front_Side_Right_Transparent.9395b21a.svg";